module.exports = __webpack_public_path__ + "img/JO.4f4d5526.png";